/* eslint-disable react-hooks/exhaustive-deps */
import MonthPicker from "./MonthPicker";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getType } from "./helper";
import MyAdminComponent from "./MyAdminComponent";
import { getPageRouteFromKey } from "./routesHelper";
import { pushLevel, setAdminOption } from "../../../../middlewares";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { addOneLevel } from "../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { useAdminsContext } from "../../../../context/admin/context/AdminManageContext";

const AllAdminsStats = () => {
  const { getStats, stats } = useStaticContext();
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { admins, getAllByAdminCompanyId, count } = useAdminsContext();

  const [currentAdmin, setCurrentAdmin] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  const [localStatistics, setLocalSetStats] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!admins) getAllByAdminCompanyId(page, pageSize);

    if (!stats && admins && admins?.length > 0) {
      loadStatistics({ year: currentYear, month: currentMonth });
    } else if (stats && admins && admins?.length > 0) {
      setLocalSetStats(buildArrayOfKeysAndValuesFromAdminObjectData(stats));
    }
  }, [stats, admins]);

  const buildArrayOfKeysAndValuesFromAdminObjectData = (obj) => {
    const result = [];
    let total_items = 0;

    for (const key in obj) {
      if (!["email", "admin_id", "last_name", "first_name", "phonenumber"].includes(String(key))) {
        total_items += obj[key];
        result.push({
          title: key,
          value: obj[key],
          route: getPageRouteFromKey({ key }),
        });
      }
    }
    setTotal(total_items);
    return result;
  };

  const loadStatistics = async ({ year, month, admin }) => {
    if (admins && admins?.length > 0) {
      await getStats({
        year,
        month,
        data: { ids: admin ? [admin] : [admins[currentAdmin]?.admin_id] },
      });
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-screen-2xl p-4 lg:p-6">
        {/* Header / Toolbar */}
        <div className="relative mb-6">
          <div className="pointer-events-none absolute -inset-x-4 -top-4 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-6 p-5 md:flex-row md:items-start md:justify-between">
              <div className="min-w-0 relative z-10">
                <h1 className="truncate text-base font-semibold tracking-tight text-gray-900">
                  {admins && admins?.length > 0
                    ? `${admins[currentAdmin]?.first_name}'s Statistics`
                    : "My Statistics"}
                </h1>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-2 rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                    Total item(s):
                    <span className="ml-1 font-semibold text-gray-900">{total}</span>
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-white px-2.5 py-1 text-[11px] text-gray-600 ring-1 ring-gray-200">
                    Period:
                    <strong className="ml-1">
                      {currentMonth}/{currentYear}
                    </strong>
                  </span>
                </div>
              </div>

              {/* MonthPicker */}
              <div className="relative z-0 w-full md:w-auto md:min-w-[420px] lg:min-w-[520px]">
                <MonthPicker
                  currentYear={currentYear}
                  currentMonth={currentMonth}
                  setTotal={setTotal}
                  setCurrentYear={setCurrentYear}
                  loadStatistics={loadStatistics}
                  setCurrentMonth={setCurrentMonth}
                  setLocalSetStats={setLocalSetStats}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Main Layout */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
          {/* Left Column: Admins */}
          <aside className="md:col-span-4 lg:col-span-3">
            <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
              <div className="flex items-center justify-between px-4 py-3">
                <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-700">
                  Team Members
                </h2>
                <div className="h-1 w-16 rounded bg-gradient-to-r from-emerald-500 via-amber-500 to-fuchsia-500 opacity-40" />
              </div>
              <div className="px-2 pb-2">
                <MyAdminComponent
                  page={page}
                  count={count}
                  admins={admins}
                  pageSize={pageSize}
                  currentYear={currentYear}
                  currentAdmin={currentAdmin}
                  currentMonth={currentMonth}
                  getAllByAdminCompanyId={getAllByAdminCompanyId}
                  setPage={setPage}
                  setTotal={setTotal}
                  setPageSize={setPageSize}
                  loadStatistics={loadStatistics}
                  setCurrentAdmin={setCurrentAdmin}
                  setLocalSetStats={setLocalSetStats}
                />
              </div>
            </div>
          </aside>

          {/* Right Column: Stats */}
          <section className="md:col-span-8 lg:col-span-9">
            <div className="mb-3 flex items-center justify-between">
              <span className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] text-gray-700">
                <span className="h-1.5 w-1.5 rounded-full bg-gray-900" />
                Overview by content type
              </span>
              <span className="text-[11px] text-gray-500">
                {currentMonth}/{currentYear}
              </span>
            </div>

            {localStatistics ? (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                {localStatistics?.map((stat, index) => {
                  const tones = [
                    { grad: "from-emerald-500 via-teal-500 to-cyan-500", soft: "bg-emerald-50", text: "text-emerald-700" },
                    { grad: "from-fuchsia-500 via-pink-500 to-rose-500", soft: "bg-pink-50", text: "text-pink-700" },
                    { grad: "from-indigo-500 via-violet-500 to-purple-500", soft: "bg-violet-50", text: "text-indigo-700" },
                    { grad: "from-amber-500 via-orange-500 to-red-500", soft: "bg-amber-50", text: "text-amber-700" },
                    { grad: "from-sky-500 via-blue-500 to-indigo-500", soft: "bg-sky-50", text: "text-sky-700" },
                    { grad: "from-lime-500 via-green-500 to-emerald-500", soft: "bg-lime-50", text: "text-lime-700" },
                  ];
                  const tone = tones[index % tones.length];

                  const label = String(stat?.title || "")
                    ?.replace(/_/g, " ")
                    ?.replace(/\b\w/g, (m) => m.toUpperCase());

                  return (
                    <Link
                      key={`${label}-${index}`}
                      to={stat?.route}
                      onClick={() => {
                        setSingleAdmin({
                          ids: [admins?.[currentAdmin]?.admin_id],
                          year: currentYear,
                          month: currentMonth,
                          noLocation: true,
                          type: getType({ field: stat?.title }),
                          route: "/content/admin/stats",
                        });

                        addOneLevel({
                          id: 0,
                          name: `${admins?.[currentAdmin]?.first_name} - ${admins?.[currentAdmin]?.last_name}`,
                          route: "/levels/first",
                          level: "",
                          country_id: 0,
                          data: {
                            data: {
                              name: "",
                              country_id: 0,
                              first_level_id: 0,
                              second_level_id: 0,
                              third_level_id: 0,
                              fourth_level_id: 0,
                              level: "",
                            },
                          },
                        });

                        pushLevel({
                          level: {
                            id: 0,
                            name: "",
                            level: "All",
                            route: "/levels/first",
                            data: null,
                          },
                        });

                        setAdminOption(sysAdmin?.admin_id);
                      }}
                      className="group focus:outline-none"
                    >
                      {/* Contained gradient frame (no overflow) */}
                      <div className="relative rounded-2xl overflow-hidden shadow-sm transition-transform duration-200 group-hover:-translate-y-0.5">
                        {/* Gradient border layer */}
                        <div className={`absolute inset-0 bg-gradient-to-br ${tone.grad} opacity-90`} />
                        {/* Card body */}
                        <div className="relative m-[1px] rounded-2xl bg-white p-4 ring-1 ring-black/5">
                          <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                              <p className="truncate text-xs uppercase tracking-wide text-gray-500">
                                {label}
                              </p>
                              {/* Subtle in-card gradient divider (replaces the old external strip) */}
                              <div className={`mt-2 h-0.5 w-16 rounded-full bg-gradient-to-r ${tone.grad} opacity-70`} />
                              <span className={`mt-2 inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium ${tone.soft} ${tone.text} ring-1 ring-black/5`}>
                                Active Items
                              </span>
                            </div>
                            <div className="shrink-0">
                              <span className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm">
                                {stat?.value}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={i} className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
                    <div className="mb-3 h-3 w-32 animate-pulse rounded bg-gray-200" />
                    <div className="ml-auto h-6 w-16 animate-pulse rounded bg-gray-200" />
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default AllAdminsStats;
